<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <img src="static\img\icon.jpeg" width="100%" />
        </div>
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <form @submit.prevent="submit" action="#/login">
                  <small
                    class="text-danger"
                    v-show="errors.has('username')"
                  >{{ errors.first('username') }}</small>
                  <div class="input-group mb-3">
                    <span class="input-group-addon">
                      <i class="icon-user"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      name="username"
                      v-validate="'required'"
                      placeholder="Username"
                      v-model="username"
                    />
                  </div>
                  <small
                    class="text-danger"
                    v-show="errors.has('password')"
                  >{{ errors.first('password') }}</small>
                  <div class="input-group mb-4">
                    <span class="input-group-addon">
                      <i class="icon-lock"></i>
                    </span>
                    <input
                      type="password"
                      class="form-control"
                      name="password"
                      v-validate="'required'"
                      placeholder="Password"
                      v-model="password"
                    />
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <vue-button-spinner
                        style="background-color: #20a8d8;color: white"
                        :is-loading="loading"
                        :disabled="loading"
                        @click="submit"
                        type="submit"
                      >
                        <span>Login</span>
                      </vue-button-spinner>
                      <!-- <button @click="submit" type="submit" class="btn btn-primary px-4">Login</button> -->
                    </div>
                    <div class="col-6 text-right">
                      <!-- <button type="button" :to="'/resetpassword'" class="btn btn-link px-0">Forgot password?</button> -->
                      <router-link :to="'/resetpassword'" class="btn btn-link px-0">Forgot password?</router-link>
                    </div>
                  </div>

                  <!-- link kinerja kpu batam -->

                  <!-- <div class="row mt-3">
                    <div class="col-6"></div>
                    <div class="col-6">
                      <router-link :to="'/pengumuman'" class="btn btn-link px-0">Kinerja KPU Batam 2022</router-link>
                    </div>
                  </div> -->

                  <!-- link kinerja kpu batam end -->
                </form>
              </div>
            </div>

            <!-- dimatikan karena hengker -->

            <div class="card d-md-down" style="">
              <div class="card-body text-center text-white bg-primary">
                <div>
                  <h2>Sign up</h2>
                  <p>Belum Memiliki User??</p>
                  <router-link :to="'/register'" class="btn btn-primary active mt-3">Register Now!</router-link>
                </div>
              </div>
              <div class="card-body text-center">
                <h3 class="text-muted">Lapor Barang Transit</h3>
                <div class="row">
                  <div class="col-md-12">
                    <router-link :to="'/menutransit'">
                      <button class="btn btn-primary">
                        <h3><i class="fa fa-truck"></i></h3>
                      </button>
                      <p class="text-muted">Klik Disini!</p>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <!-- dimatikan karena hengker end -->

            <!-- alternatif karena hengker -->

            <!-- <div class="card d-md-down">
              <div class="card-body text-center text-white bg-primary">
                <h2>Belum Memiliki User??</h2>
                <h5 style="color: yellow;">Scan Here!!!</h5>
                <img style="height: 14rem; width: 14rem;" src="static\img\qr-regis.png" alt="">
              </div>
            </div> -->

            <!-- alternatif karena hengker end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import swal from 'sweetalert'
import VueButtonSpinner from 'vue-button-spinner'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  // computed: {
  //   ...mapGetters({
  //     authenticated: 'auth/authenticated',
  //     user: 'auth/user'
  //   })
  // },
  components: {
    VueButtonSpinner
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user'
    }),
    loading () {
      return this.$store.getters['auth/isLoading']
    },
    alert () {
      return this.$store.getters['auth/loginAlert']
    }
  },
  methods: {
    // login () {
    //   this.$Progress.start()
    //   var data = {
    //     username: this.username,
    //     password: this.password
    //   }
    //   this.$http.post('login', data)
    //     .then(response => {
    //       if (response.data.login === true) {
    //         if (response.data.locked > 5) {
    //           swal('User', 'Akses anda sudah dicabut/diblokir', 'error')
    //         } else {
    //           this.$auth.setUser(response.data.user, response.data.pass, response.data.ppjk, response.data.npwp)
    //           if (Date.now() > Date.parse(response.data.tgl_expired)) {
    //             this.$router.push('changepass')
    //           } else {
    //             this.$router.push('dashboard')
    //           }
    //         }
    //       } else {
    //         swal('', 'User or Password Wrong', 'error')
    //       }
    //       this.$Progress.finish()
    //     })
    // },
    // login2 () {
    //   this.$Progress.start()
    //   var data = {
    //     USER_NAME: this.username,
    //     password: this.password
    //   }
    //   this.$http.post('otentikasi/signin', data)
    //     .then(response => {
    //       swal('success', response.token, 'success')
    //       this.$Progress.finish()
    //     })
    // },
    ...mapActions({
      login: 'auth/login'
    }),
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var data = {
            USER_NAME: this.username,
            password: this.password
          }
          // login tanpa MFA
          // this.login(data).then(() => {
          //   this.$store.commit('auth/SET_LOADING', false)
          //   this.$router.push({ path: 'dashboard' })
          //   // var user = {
          //   //   name: this.$store.state.auth.user.username,
          //   //   email: this.$store.state.auth.user.email
          //   // }
          //   // this.$Tawk.$updateChatUser(user)
          // })
          // login dengan MFA
          this.login(data).then((response) => {
            this.$store.commit('auth/SET_LOADING', false)
            if (response.data.tfa_required) {
              // this.$store.commit('tfa/setUserData', {
              //   username: data.USER_NAME,
              //   secretKey: response.data.secret_key,
              //   qrCodeUrl: response.data.qr_code_url
              // })
              localStorage.setItem('USER_NAME', data.USER_NAME)
              localStorage.setItem('password', data.password)
              this.$router.push({path: '/tfa/setup'})
            } else if (response.data.tfa_verification_needed) {
              localStorage.setItem('USER_NAME', data.USER_NAME)
              localStorage.setItem('password', data.password)
              // this.$store.commit('tfa/setUserData', { username: data.USER_NAME, password: data.password })
              this.$router.push({ path: '/tfa/verify' })// Arahkan ke halaman verifikasi OTP
            } else {
              this.$router.push({ path: '/dashboard' })
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue?cce193b4